<template>
    <div class="slider">
      <v-carousel hide-delimiters hide-controls>
        <v-carousel-item v-for="(item, i) in items" 
                          :key="i" :src="item.src"
                          reverse-transition="fade"
                          transition="fade">
        </v-carousel-item>
      </v-carousel>
            <div class="slide-frame">

                <span v-if="language==='EN'">
                    <h4>WELCOME TO</h4>
                    <h3>THE OFICIAL WEBSITE OF </h3>
                    <h1>Oksana Kowcz</h1>
                    <h3>DRAMA & MOVIE THEATRE ACTRESS </h3>
                    <p class="white--text">SINGER</p>                   
                    <h4>INSTRUCTOR & COACH</h4>
                </span>

                <span v-if="language==='UA'">
                    <h4>ВІТАЄМО</h4>
                    <h3>НА ОФІЦІЙНОМУ САЙТІ</h3>
                    <h1>Оксани Ковч</h1>
                    <h3 class="text-uppercase">Акторка Драматичного Театру і Кіно</h3>
                    <p class="white--text">СПIВАЧКА</p>   
                    <h4 class="text-uppercase">Інструктор i тренер</h4>
                </span>

                <span v-if="language==='RU'">
                    <h4>ДОБРО ПОЖАЛОВАТЬ</h4>
                    <h3>НА ОФИЦИАЛЬНЫЙ САЙТ</h3>
                    <h1>Оксана Ковч</h1>
                    <h3>АКТРИСА ДРАМАТИЧЕСКОГО ТЕАТРА И КИНО </h3>
                    <p class="white--text">ПЕВИЦА</p>
                    <h4 class="text-uppercase">Инструктор и тренер</h4>
                </span>                                

            </div>      
      <div class="slide-footer">
        <span v-if="language === 'EN'">DRAMA & MOVIE THEATRE ACTRESS | SINGER | INSTRUCTOR & COACH</span>
        <span v-if="language === 'UA'">Акторка Драматичного Театру | Кіно | Інструктор | Тренер</span>
        <span v-if="language === 'RU'">АКТРИСА ДРАМАТИЧЕСКОГО ТЕАТРА И КИНО</span>
        
      </div>
    </div>
</template>

<script>
  import { MyFunctions } from '@/data/functions.js'
  export default {
    data: () => ({
      language: '',
      items: [
        { 
          title: 'WELCOME TO',
          src: '/img/slide-1a.png',
          text: 'DRAMA & MOVIE THEATRE ACTRESS'
        },
        { 
          title: 'WELCOME TO',
          src: '/img/slide-2a.png',
          text: 'MASTER OF CEREMONY'
        },        
      ]
    }),  
    mounted(){
      this.language = MyFunctions.getLanguage()
  },
  }
</script>

<style>
  .fade-enter { 
    opacity: 0; 
  }
  .fade-enter-active { 
    transition: 1s; 
  }
  .fade-leave-active { 
    transition: 1s; opacity: 0; 
  }
  .slider {
    position: relative;
    max-width: 920px!important;
    margin: auto!important;
  }
  .slide-frame {
    text-align: center;
    position: absolute;
    top: 130px;
    right: 50px;
  }
  .slide-frame h1 {
    color: #B5B0A5!important;
    font-size: 62px;
    font-family: 'Open Sans Condensed', sans-serif;
    letter-spacing: -1px;
    margin-top: -10px;
  }
  .slide-frame h2 {
    color: #83807A;
    font-size: 22px;
  }  
  .slide-frame h2 strong {
    color: #339900;
    display: block;
    font-size: 18px;
    font-family: 'Open Sans Condensed', sans-serif;
    margin-bottom: 10px;
  }
  .slide-frame h3 {
    color: #83807A;
    font-size: 26px;
    font-family: 'Open Sans Condensed', sans-serif;
  }
  .slide-frame h4 {
    color: #339900;
    font-size: 14px;
    font-family: 'Open Sans Condensed', sans-serif;
  }
  .slide-frame p {
    font-size: 24px;
    margin-top: 0px;
  }
  .slide-footer {
    position: absolute;
    opacity: 0.5;
    background-color: #764901;
    width: 100%;
    padding: 5px 10px;
    bottom: 0;
    left: 0;
    color: #fff;
    font-size: 20px;
  }
</style>
